

























































































import _ from 'underscore';
import { Component, Vue } from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import binaryDownload from '@/services/BinaryDownloader';
import { dateFormatter, ucWords } from '@/services/inputTools';
import SecurityLevels from '@/classes/SecurityLevel';
import moment from 'moment';

@Component({
    filters: {
        dateFormatter,
        ucWords
    }
})
export default class UserSearch extends Vue {

    // Filters
    private filterUsername: string = '';
    private filterLastName: string = '';
    private filterUbcId: string = '';
    private filterJobCorpsCenter: number = 0;
    private filterStatus: boolean | null = null;
    private filterSecurityLevel: string | null = null;
    private filterFieldCoordinator: number = 0;

    private securityLevels = SecurityLevels;

    private currPage: number = 1;
    private perPage: number = 10;

    get currentPage(): number {
        if (this.currPage > this.pages) {
            return this.pages;
        } else {
            return this.currPage;
        }
    }

    set currentPage(num: number) {
        this.currPage = num;
    }

    get pages(): number {
        const num: number = Math.ceil(this.totalRows / this.perPage);
        if (num === 0) {
            return 1;
        } else {
            return num;
        }
    }

    get totalRows(): number {
        return this.items.length;
    }

    get fieldCoordinators(): UserProfile[] {
        const fcs: UserProfile[] =  this.$store.getters['users/getFieldCoordinators']();

        if (fcs !== undefined) {
            return fcs;
        } else {
            return [];
        }
    }

    get fields() {
        return [{
                label: 'Name',
                key: 'lastName',
                sortable: true
            }, {
                key: 'username',
                label: 'Username'
            }, {
                key: 'securityLevel',
                label: 'Security Level',
                sortable: true
            }, {
                key: 'ubcId',
                label: 'UBC ID',
                sortable: true
            }, {
                key: 'lastLogin',
                label: 'Last Login',
                sortable: true
            }, {
                key: 'active',
                label: 'Active',
                sortable: true
            }, {
                key: 'edit',
                label: ''
            }
        ];
    }

    get selectedFieldCoordinator(): UserProfile | null {
        if (0 === this.filterFieldCoordinator) {
            return null;
        } else {
            const fieldCoordinator: UserProfile | undefined = this.$store.getters.getUserProfileById(this.filterFieldCoordinator);
            if (fieldCoordinator !== undefined) {
                return fieldCoordinator;
            } else {
                return null;
            }
        }
    }

    get items(): UserProfile[] {

        const ups = this.$store.getters.getUserProfileList;

        const uname = '' === this.filterUsername ? null : new RegExp(this.filterUsername, 'i');
        const lname = '' === this.filterLastName ? null : new RegExp(this.filterLastName, 'i');
        const ubcId = '' === this.filterUbcId ? null : new RegExp(this.filterUbcId, 'i');

        return _.chain(ups)
            .filter((u: UserProfile) => {
                return null === uname || uname.test(u.emailAddress as string);
            })
            .filter((u: UserProfile) => {
                return null === lname || lname.test(u.lastName as string);
            })
            .filter((u: UserProfile) => {
                return null === ubcId || ubcId.test(u.ubcId as string);
            })
            .filter((u: UserProfile) => {
               // return 0 === this.filterJobCorpsCenter || this.filterJobCorpsCenter === u.jobCorpsCenterPrimaryId;
                return 0 === this.filterJobCorpsCenter ||
                      (u.jobCorpsCenterIds !== undefined && u.jobCorpsCenterIds.includes(this.filterJobCorpsCenter) );

            })
            .filter((u: UserProfile) => {
                return null === this.filterStatus || this.filterStatus === u.active;
            })
            .filter((u: UserProfile) => {
                return null === this.filterSecurityLevel || this.filterSecurityLevel === u.securityLevel;
            })
            .filter((u: UserProfile): boolean => {
                if (this.selectedFieldCoordinator === null) {
                    return true;
                } else {
                    if (u.jobCorpsCenterIds !== undefined && this.selectedFieldCoordinator.jobCorpsCenterIds !== undefined) {
                        return u.jobCorpsCenterIds.some((centerId: number): boolean => {
                            if (this.selectedFieldCoordinator !== null && this.selectedFieldCoordinator.jobCorpsCenterIds !== undefined) {
                                return this.selectedFieldCoordinator.jobCorpsCenterIds.indexOf(centerId) >= 0;
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                }
            })
            .sortBy((u: UserProfile) => {
                return u.lastName;
            })
            .value();
    }

    get jobCorpCenters() {
        return this.$store.getters.getJobCorpsCenters;
    }

    private clearFilters(): void {
        this.filterUsername = '';
        this.filterLastName = '';
        this.filterUbcId = '';
        this.filterJobCorpsCenter = 0;
        this.filterStatus = null;
        this.filterSecurityLevel = null;
        this.filterFieldCoordinator = 0;
    }

    private exportResults(): void {

        const ids = _.pluck(this.items, 'id');
        binaryDownload('POST', '/api/v1/users/export', JSON.stringify(ids))
            .catch((err) => {
                bootbox.alert(err.message);
            });
    }
}
